import React from "react";
import { Modal, Form, Input } from 'antd';

import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";

import DynamicButton from "../../components/frame/DynamicButton";

import ReactAbstract from "../../components/abstract/React.abstract";
import ApprovalAccessService from "../../services/Approval/approval-access-service";

class ApprovalAccess extends ReactAbstract {

	dataMode = 1
	initReload = false
	moduleName = "approval"
	childModuleName = "ApprovalAccess"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		filters: {},
		data: [],
		dataStatus: "unload",
		formColumn: [],
		approvalflow_name:'',
		role_name:''
	}

	actions = {
		selectAction: ApprovalAccessService.selectApprovalAccess,
		createAction: ApprovalAccessService.createApprovalAccess,
		updateAction: ApprovalAccessService.updateApprovalAccess,
		deleteAction: ApprovalAccessService.deleteApprovalAccess,
	}

	headerColumn = [{
		title: "新增",
		access: "c_value",
		icon: "plus-circle-o",
		click: () => this.setState({
			currentModalStatus: true,
			currentDataStatus: "unload",
			currentIndex: null
		}, () => ApprovalAccessService.initiaApprovalAccess({}, res => {
			if (res.data.Success) {
				this.setState({
					currentDataStatus: "loaded",
					currentData: { role_ids: [] },
					formColumn: [{
						label: "审批步骤",
						key: "approvalflow_name",
						type: "input",
						span: 24
					}, {
						label: "角色",
						key: 'role_ids',
						type: "multiSelectex",
						children: res.data.Object.roles.map(role => {
							return { id: role.id, text: role.name }
						}),
						span: 24
					}
					]
				})
			} else {
				this.setState({ currentDataStatus: "error" })
			}
		}, err => this.setState({ currentDataStatus: "error" })))
	}, {
		title: "删除",
		access: "d_value",
		icon: "delete",
		click: this.publicDelete
	}
	]

	tableColumn = [
		{
			title: '审批步骤',
			dataIndex: 'approvalflow_name',
			key: 'approvalflow_name',
			className: 'table-global-head'
		}, {
			title: '角色',
			dataIndex: 'role_names',
			key: 'role_names',
			className: 'table-global-head'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head',
			render: (text, record, index) => (
				<DynamicButton column={this.buttonColumn(text, record, index)}
					module={this.childModuleName}
					access={this.props.access} />
			)
		}
	]

	buttonColumn = (text, record, index) => [{
		size: "small",
		type: "default",
		icon: "edit",
		title: "编辑",
		access: "u_value",
		click: () => this.setState({
			currentModalStatus: true,
			currentDataStatus: "unload",
			currentIndex: index,
		}, () => ApprovalAccessService.detailApprovalAccess({ modelId: record.id }, res => {
			// console.log(res)
			if (res.data.Success) {
				this.setState({
					currentDataStatus: "loaded",
					currentData: res.data.Object.details,
					formColumn: [{
						label: "审批步骤",
						key: "approvalflow_name",
						type: "input",
						span: 24
					}, {
						label: "角色",
						key: 'role_ids',
						type: "multiSelectex",
						children: res.data.Object.roles.map(role => {
							return { id: role.id, text: role.name }
						}),
						span: 24
					}
					]
				})
			} else {
				this.setState({ currentDataStatus: "error" })
			}
		}, err => this.setState({ currentDataStatus: "error" })))
	}
	]

	publicSubmit = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const currentData = {
					...this.state.currentData,
					...values
				}
				const callee = null === this.state.currentIndex ?
					this.publicCreate : this.publicUpdate;
				// console.log(currentData, callee)
				callee(currentData, () => this.publicChange());
			}
		})
	}
	setNameFilter = name => {
		this.setState({ approvalflow_name: name });
		this.publicChange({
			approvalflow_name: name,
			role_name: this.state.role_name
		}, "reload");
	}
	setRoleNameFilter = name => {
		this.setState({ role_name: name });
		this.publicChange({
			role_name: name,
			approvalflow_name: this.state.approvalflow_name
		}, "reload");
	}
	render() {
		return (
			<div className="app-module-item">
				<div className="app-module-header">
					<DynamicButton column={this.headerColumn}
						module={this.childModuleName}
						access={this.props.access} />

					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Input.Search
							placeholder="审批步骤"
							onSearch={this.setNameFilter}
							style={{ width: 200 }}
							enterButton />
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Input.Search
							placeholder="角色"
							onSearch={this.setRoleNameFilter}
							style={{ width: 200 }}
							enterButton />
					</div>
				</div>
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="审批步骤"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.publicSubmit} >
					<DynamicForm column={this.state.formColumn}
						form={this.props.form}
						loadStatus={this.state.currentDataStatus}
						dataSource={this.state.currentData} />
				</Modal>
				<div>
					<DynamicTable column={this.tableColumn}
						dataStatus={this.dataSource().dataStatus}
						dataSource={this.dataSource().data.Data}
						pagination={{
							total: this.dataSource().data.Total,
							pageSize: this.dataSource().data.PageSize,
							current: this.dataSource().filters.page
						}}
						rowSelection={this.rowSelection}
						setPageFilter={this.publicChange} />
				</div>
			</div>
		)
	}
}

ApprovalAccess = Form.create()(ApprovalAccess);

export default LayoutWrapper(ApprovalAccess);


// WEBPACK FOOTER //
// ./src/routes/Approval/ApprovalAccess.js